//
// Copyright 2022 Avvia Life, All Rights Reserved
//

import {
  rsInit,
  rsCheckType,
} from '../remote-state/core'

import {
  useFile,
  useFileLimits,
  fileLimitsType,
} from './files'

import {
  objGetLang,
} from '../components/ALI18N'

//

function useImage( id, { alt, caption } = {} ) {
  const file = useFile( id, 'image' )
  file.meta = {}
  file.meta.alt = alt
  file.meta.caption = caption
  return rsInit( { ...file }, 'image' )
}

function imageID( img ) {
  rsCheckType( img, 'image')
  return img.data?.id
}

function imageUrl( img ) {
  rsCheckType( img, 'image')
  return img.data?.url || ' '
}

function imageAlt( img ) {
  rsCheckType( img, 'image')
  return objGetLang( img.meta.alt ) || objGetLang( img.data?.image?.alt  )
}

function imageCaption( img ) {
  rsCheckType( img, 'image')
  return objGetLang( img.meta.caption ) || objGetLang( img.data?.image?.alt  )
}

function imageWidth( img ) {
  rsCheckType( img, 'image')
  return objGetLang( img.data?.image?.width  )
}

function imageHeight( img ) {
  rsCheckType( img, 'image')
  return objGetLang( img.data?.image?.height  )
}

function useImageLimits( role ) {
  const fileLimits = useFileLimits( { role } )
  const imgLimits = fileLimitsType( fileLimits, 'image' )

  return rsInit( { ...fileLimits, data : imgLimits }, 'imgLimits' )
}

function getImageLimits( fileLimits ) {
  const imgLimits = fileLimitsType( fileLimits, 'image' )
  return rsInit( { ...fileLimits, data : imgLimits }, 'imgLimits' )
}

function imageLimitsTypes( imgLimits ) {
  rsCheckType( imgLimits, 'imgLimits' )
  if( ! imgLimits.data ) return ''
  return imgLimits.data.types
}

function imageLimitsRatio( imgLimits ) {
  rsCheckType( imgLimits, 'imgLimits' )
  if( ! imgLimits.data ) return 1
  return imgLimits.data.ratio
}

//

export {
  useImage,
  imageID,
  imageUrl,
  imageAlt,
  imageCaption,
  imageWidth,
  imageHeight,

  useImageLimits,
  getImageLimits,
  imageLimitsTypes,
  imageLimitsRatio,
}